import { motion } from "framer-motion";
import { ArrowDown, Smartphone, Code2 } from "lucide-react";

export const Hero = ({ isLoaded }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: [0.25, 0.1, 0.25, 1] },
    },
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex flex-col justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1761078739436-ccee01f3d89c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxkYXJrJTIwYWJzdHJhY3QlMjB0ZXh0dXJlJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3NzU4OTg4MDd8MA&ixlib=rb-4.1.0&q=85')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      {/* Gradient Overlay */}
      <div className="absolute inset-0 z-0 hero-gradient" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-12 lg:px-24 pt-32">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate={isLoaded ? "visible" : "hidden"}
          className="max-w-4xl"
        >
          {/* Overline */}
          <motion.p
            variants={itemVariants}
            className="font-mono text-xs uppercase tracking-[0.2em] text-[#D4FF00] mb-6 flex items-center gap-2"
          >
            <Smartphone size={14} />
            Mobile App Developer
          </motion.p>

          {/* Main Title */}
          <motion.h1
            variants={itemVariants}
            className="text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tighter leading-none text-white mb-6"
          >
            Hello, I'm{" "}
            <span className="text-[#D4FF00]">Vaidehi Virani</span>
          </motion.h1>

          {/* Subtitle */}
          <motion.p
            variants={itemVariants}
            className="text-lg sm:text-xl text-[#888888] leading-relaxed max-w-2xl mb-10"
          >
            Professional Mobile App Developer specializing in{" "}
            <span className="text-white">Android</span> &{" "}
            <span className="text-white">iOS</span> development. Building
            scalable, user-centric applications that make a difference.
          </motion.p>

          {/* CTA Buttons */}
          <motion.div
            variants={itemVariants}
            className="flex flex-wrap gap-4"
          >
            <a
              href="#projects"
              data-testid="hero-view-work-btn"
              className="bg-[#D4FF00] text-black font-bold uppercase tracking-wider px-8 py-4 hover:bg-white transition-colors duration-300 btn-press inline-flex items-center gap-2"
            >
              <Code2 size={18} />
              View My Work
            </a>
            <a
              href="#contact"
              data-testid="hero-contact-btn"
              className="bg-transparent text-white border border-white/20 font-bold uppercase tracking-wider px-8 py-4 hover:border-[#D4FF00] hover:text-[#D4FF00] transition-colors duration-300 btn-press"
            >
              Get In Touch
            </a>
          </motion.div>
        </motion.div>

        {/* Scroll Indicator */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5, duration: 0.8 }}
          className="absolute bottom-10 left-1/2 -translate-x-1/2"
        >
          <a
            href="#about"
            data-testid="scroll-indicator"
            className="flex flex-col items-center gap-2 text-[#888888] hover:text-[#D4FF00] transition-colors"
          >
            <span className="font-mono text-xs uppercase tracking-widest">Scroll</span>
            <motion.div
              animate={{ y: [0, 8, 0] }}
              transition={{ duration: 1.5, repeat: Infinity }}
            >
              <ArrowDown size={20} />
            </motion.div>
          </a>
        </motion.div>
      </div>
    </section>
  );
};
